import React from 'react';
import {Link} from 'react-router-dom'
import GoogleFontLoader from 'react-google-font-loader';
import 'pure-react-carousel/dist/react-carousel.es.css';

import './App.css';
import Header from './Header';
import Navigation from './Nav';
import Footer from './Footer';

import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext 
        } from 'pure-react-carousel';

import { FaArrowRight, FaArrowLeft, FaDraftingCompass, FaCube, FaRegBuilding, FaArrowCircleUp
        } from 'react-icons/fa';

import { Container, Button, Row, Col, 
         Card, CardTitle, CardText, CardImg
        } from 'reactstrap';
      

function Architecture() {

     return (

        <div id="pageUp" style={{backgroundColor:'#f5f5f5'}}>
          <Header />
          <Navigation/>

        {/* GOOGLE FONTS -------------------------------------------------------------*/}       
<GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [400, '400i'],
              },
              {
                font: 'Roboto Condensed',
                weights: [400, 700],
              },
              {
                  font: 'Titillium Web',
                  weights: [400, 700],
                },
                {
                  font: 'Poppins',
                  weights: [400, 700],
                },
            ]}
            subsets={['cyrillic-ext', 'greek']}
             />

{/* Header ------------------------------------------------------         */}
        <Row>
        
            <Col className='text-center' style={{ 
                animationName:'example', 
                animationDuration:'20s',
                backgroundColor:'#34b6bc', 
                height:'200px',
                borderBottomRightRadius:'90%',
                borderBottomLeftRadius:'50%'
                }}>
            <h2 style={{marginTop:'50px', color:'black'}}>Images</h2>
            <Link to="/" style={{fontSize:'12px', color:'white', 
                                fontWeight:'bold',
                                marginRight:'10px'
                                }}>
             ACCUEIL</Link>
            - Du concept à la réalisation
            </Col>
        </Row>

        <Container>
{/* INTRODUCTION -------------------------------------------------------- */}
        
        <CarouselProvider
        style={{marginTop:'30px'}}
        naturalSlideWidth={100}
        naturalSlideHeight={50}
        totalSlides={6}
        >
        <Slider>
       
         {/* ARTS NUMERIQUES -------------------------------------- */}

         <Slide index={0}>
         <h1 style={{fontSize:'20px', fontFamily:'Poppins', backgroundColor:'#34b6bc', color:'white'}}>
             Centre des Arts Numériques de Paris-Bercy</h1>
             <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/diplome1.JPG"
                  alt="Card image cap"
                />
          </Slide>
        
          <Slide index={1}><CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/diplome2.JPG"
                  alt="Card image cap"
                />
            </Slide>
            <Slide index={2}><CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/diplome3.JPG"
                  alt="Card image cap"
                />
            </Slide>
            <Slide index={3}><CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/maquette.JPG"
                  alt="Card image cap"
                />
            </Slide>

          {/* ETUDIANTS -------------------------------------- */}

          <Slide index={4}>
          <h1 style={{fontSize:'25px', fontFamily:'Impact', backgroundColor:'#34b6bc', color:'white'}}>
             Maison des étudiants à Orsay</h1>
             <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/etudiant2.JPG"
                  alt="Card image cap"
                />
          </Slide>

          {/* TGI -------------------------------------- */}

          <Slide index={5}>
          <h1 style={{fontSize:'25px', fontFamily:'Impact', backgroundColor:'#34b6bc', color:'white'}}>
             Tribunal de Grande Instance de Ivry-sur-Seine</h1>
             <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/architecture/tgi.JPG"
                  alt="Card image cap"
                />
          </Slide>
        
          </Slider>

        {/* Slider buttons -------------------------------------------------------   */}

        <Col className='text-center' style={{marginTop:'10px'}}>
        <ButtonBack style={{backgroundColor:'#34b6bc'}}>
            <FaArrowLeft 
            size={23} color={'white'} style={{marginLeft:'30px', marginRight:'10px'}}/>
        </ButtonBack>
        
        <ButtonNext style={{backgroundColor:'#34b6bc'}}>
            <FaArrowRight 
            size={23} color={'white'} style={{marginLeft:'30px', marginRight:'10px'}}/>
        </ButtonNext>
        </Col>
    
      </CarouselProvider>

{/* PRESENTATION -------------------------------------------------------- */}

      <Col className='text-center' style={{marginTop:'50px',
                                             fontFamily:'Poppins', color:'#767676'}}>
        Avant de me touner vers le développement mobile et web, j'ai été diplômée de
        l'école l'Ecole Nationale d'Architecture de Paris-Val-de-Seine
         (ENSAPVS). Cette formation m'a permis de découvrir l'idée de concept, 
         de comment le matérialiser
         et le réaliser de A à Z. Suite à mes études, j'ai ensuite travaillé pour plusieurs agences
          dont celle de Jean-Paul Viguier & associés.
         Dans cette rubrique, il est présenté mes projets réalisés à l'école. 
        </Col>

{/* MES OUTILS TECHNIQUES --------------------------------------------------------- */}

<Col className='text-center' style={{marginTop:'30px', fontFamily:'Poppins', color:'#767676'}}>  
        <h1 style={{fontSize:'25px', marginTop:'100px'}}>Mes outils techniques</h1>
</Col>
   
    {/* LIGNE --------------------------------------------------------------------*/}
    <div style={{height:'1px', width:'100%', marginBottom:'50px', backgroundColor:'#7a7a7a'}}>
         </div>


{/* CARTE LOGICIEL --------------------------------------------------- */}
 <Row style={{marginBottom:'50px'}}>
      <Col >
        <Card body>
            <CardTitle>
            <FaDraftingCompass size={60} color={'#34b6bc'}/>
            <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                        marginTop:'20px', marginBottom:'0px'}}>
                         Aide à la conception</h1>
            </CardTitle>
                <CardText>
                    <ul>
                    <li>Dessin à la main</li>
                    <li>technique de Rotring</li>
                    <li>Autocad</li> 
                    </ul>
                </CardText>
        </Card>
      </Col>
      <Col >
        <Card body>
            <CardTitle>
            <FaRegBuilding size={60} color={'#34b6bc'}/>
            <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
     marginTop:'20px', marginBottom:'0px'}}>
         Images 2D et présentation</h1>
         </CardTitle>
            <CardText>
                    <ul>
                    <li>Photoshop</li>
                    <li>InDesign</li>
                    <li>Lightroom</li>
                    </ul>
            </CardText>
        </Card>
      </Col>
      <Col >
        <Card body>
            <CardTitle>
              <FaCube size={60} color={'#34b6bc'}/>
              <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                           marginTop:'20px', marginBottom:'0px'}}>
                           Images 3D et texture</h1>
            </CardTitle>
                <CardText>
                        <ul>
                        <li>Rhinoceros</li>
                        <li>sketchup</li>
                        <li>Artlantis</li>
                        </ul>
                </CardText>
        </Card>
      </Col>
</Row>

{/* RETOUR HAUT DE PAGE  ------------------------------------------------------- */}
<Col className='text-center' style={{marginTop:'50px'}}>
    <a href="#pageUp" name="pageUp">
        <Button style={{backgroundColor:'#f5f5f5', borderWidth:'0px'}}>
        <FaArrowCircleUp 
            size={35} color={'#34b6bc'} 
            style={{backgroundColor:'white',
            borderRadius:'50%'
        }}/>
        </Button>
    </a>
    </Col>
    

    <Col className='text-center'>
    <p style={{marginTop:'20px', marginBottom:'100px',
                fontFamily:'Poppins'}}>Retour en Haut de la page</p>
    </Col>



      </Container>





        <Footer />
        </div>

     )
}

export default Architecture;